import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4250b998"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-top" }
const _hoisted_2 = { class: "aside-top-company" }
const _hoisted_3 = { class: "aside-top-company-name" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 会员主页 ")
const _hoisted_5 = { class: "aside-nav" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "aside-nav-head" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aside-nav-head-label" }, "我的", -1))
const _hoisted_9 = { class: "aside-nav-logo-head" }
const _hoisted_10 = { class: "aside-nav-head-name" }
const _hoisted_11 = { class: "aside-nav-my" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aside-nav-my-title" }, "个人事务", -1))
const _hoisted_13 = { class: "aside-nav-my-list" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 我的消息")
const _hoisted_15 = {
  key: 0,
  class: "aside-nav-my-list-line-tips"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 站内信")
const _hoisted_17 = {
  key: 0,
  class: "aside-nav-my-list-line-tips"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 我报名的")
const _hoisted_19 = {
  key: 0,
  class: "aside-nav-my-list-line-tips"
}
const _hoisted_20 = { class: "aside-nav-my" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aside-nav-my-title" }, "我的帐号", -1))
const _hoisted_22 = { class: "aside-nav-my-list" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "aside-nav-md-title" }

import { useRouter } from 'vue-router';

import { defineComponent } from 'vue';
import { shallowReactive } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import router from '@/router/index';
import { ref, watch } from 'vue';
import tool from '@/utils/tool';



export default /*#__PURE__*/_defineComponent({
  props: {
  tab: {
    type: Array,
    default: [],
  },
},
  setup(__props) {

const props = __props

const ustore = useStore();

var bindData = shallowReactive({
  loginMember:
    ustore.state.loginMember == undefined ? {} : ustore.state.loginMember,
  newsNotReadCount: 0,
  noticesNotReadCount: 0,
  applyNotReadCount: 0,
});

watch(() => ustore.state.loginMember, (newValue: any, oldValue: any) => {
  bindData.loginMember = newValue;
});

const currPath = ref(router.currentRoute.value.path);

const handleToRouter = (path: string) => {
  currPath.value = path;
};

const handleToMyPage = (index: number) => {
  switch (index) {
    case 0:
      currPath.value = '/middleGround/my/news';
      router.push(currPath.value);
      break;
    case 1:
      currPath.value = '/middleGround/my/apply';
      router.push(currPath.value);
      break;
    case 2:
      currPath.value = '/middleGround/my/subscribe';
      router.push(currPath.value);
      break;
    case 3:
      currPath.value = '/middleGround/my/information';
      router.push(currPath.value);
      break;
    case 4:
      currPath.value = '/middleGround/my/password';
      router.push(currPath.value);
      break;
    case 5:
      currPath.value = '/middleGround/my/notices';
      router.push(currPath.value);
      break;
  }
};

const goToHome = () => {
  router.push("/company/companyIndex/" + bindData.loginMember.companyCode);
}

store
  .dispatch('newsModule/pageRssActivityReadList', {
    curPage: 1,
    pageSize: 1,
    filtrate: {
      isRead: 'N',
      activityStatus: '',
      searchTime: '',
      keyword: '',
    },
  })
  .then(
    (data) => {
      //成功
      bindData.newsNotReadCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );

store
  .dispatch('noticesModule/countNoticeNotRead', {
  })
  .then(
    (data) => {
      //成功
      bindData.noticesNotReadCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );

store
  .dispatch('applyModule/pageActivityApplyReadList', {
    curPage: 1,
    pageSize: 1,
    filtrate: {
      isRead: 'N',
      auditStatus: '',
      searchTime: '',
      keyword: '',
    },
  })
  .then(
    (data) => {
      //成功
      for (var index in data.result) {
        const obj = data.result[index];
        if (!obj.rssCompanyLogo || obj.rssCompanyLogo.length <= 0) {
          obj.rssCompanyLogo = require('@/assets/no_pict.png');
        }
        if (!obj.activityThumbnailUrl || obj.activityThumbnailUrl.length <= 0) {
          obj.activityThumbnailUrl = require('@/assets/no_pict.png');
        }
        if (!obj.activityImgUrl || obj.activityImgUrl.length <= 0) {
          obj.activityImgUrl = require('@/assets/no_pict.png');
        }
      }
      bindData.applyNotReadCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(tool).isNotNull(_unref(bindData).loginMember.companyLogo))
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              class: "aside-top-company-logo",
              fit: "fill",
              src: _unref(bindData).loginMember.companyLogo
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (_unref(tool).isNull(_unref(bindData).loginMember.companyLogo))
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 1,
              class: "aside-top-company-logo",
              fit: "fill",
              src: require('@/assets/no_pict.png'),
              lazy: true
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(bindData).loginMember.companyName), 1)
      ]),
      _createElementVNode("div", {
        class: "aside-top-title",
        onClick: goToHome
      }, [
        _createVNode(_component_el_image, {
          class: "aside-top-title-icon",
          src: require('@/assets/icon_home.png')
        }, null, 8, ["src"]),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (props.tab[0].title === '个人事务')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_container, { class: "aside-nav-logo" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    (_unref(tool).isNotNull(_unref(bindData).loginMember.avatarUrl))
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _unref(bindData).loginMember.avatarUrl,
                          fit: "scale-down",
                          lazy: true
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (_unref(tool).isNull(_unref(bindData).loginMember.avatarUrl))
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 1,
                          else: "",
                          src: require('@/assets/no_pict.png'),
                          fit: "scale-down",
                          lazy: true
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(bindData).loginMember.name), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/news'),
            }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToMyPage(0)))
                }, [
                  _hoisted_14,
                  (_unref(bindData).newsNotReadCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(bindData).newsNotReadCount), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/notices'),
            }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToMyPage(5)))
                }, [
                  _hoisted_16,
                  (_unref(bindData).noticesNotReadCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(bindData).noticesNotReadCount), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/apply'),
            }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToMyPage(1)))
                }, [
                  _hoisted_18,
                  (_unref(bindData).applyNotReadCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(bindData).applyNotReadCount), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/subscribe'),
            }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToMyPage(2)))
                }, " 我关注的 ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/information'),
            }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleToMyPage(3)))
                }, " 个人资料 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["aside-nav-my-list-line", {
              isActive: currPath.value.startsWith('/middleGround/my/password'),
            }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (handleToMyPage(4)))
                }, " 改密码 ", 2)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tab, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "aside-nav-md",
                key: index
              }, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(item.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (obj) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "aside-nav-md-list",
                    key: obj.id
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
              isActive: currPath.value
                .toLowerCase()
                .startsWith(obj.path.toLowerCase()),
            })
                    }, [
                      _createVNode(_component_router_link, {
                        class: "aside-nav-md-list-line",
                        to: obj.path,
                        onClick: ($event: any) => (handleToRouter(obj.path))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(obj.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "onClick"])
                    ], 2)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})